import { cn } from '@opendoor/atoms/utils';

const SF_HEART_OUTLINE_PATH =
  'M0 6.01242C0 9.76763 3.15035 13.4756 8.06467 16.6396C8.32676 16.8061 8.65212 16.9766 8.87783 16.9766C9.10195 16.9766 9.4289 16.8061 9.69819 16.6396C14.6053 13.4756 17.7557 9.76763 17.7557 6.01242C17.7557 2.77928 15.5234 0.536133 12.6489 0.536133C10.9786 0.536133 9.66814 1.30482 8.87783 2.46287C8.10193 1.31203 6.77548 0.536133 5.10679 0.536133C2.23224 0.536133 0 2.77928 0 6.01242ZM1.7694 6.00451C1.7694 3.77419 3.23524 2.27706 5.20153 2.27706C6.78902 2.27706 7.68445 3.23893 8.23587 4.07829C8.47793 4.43302 8.64632 4.5471 8.87783 4.5471C9.10933 4.5471 9.25857 4.42423 9.51661 4.07829C10.112 3.25177 10.9738 2.27706 12.5541 2.27706C14.5204 2.27706 15.9847 3.77419 15.9847 6.00451C15.9847 9.11584 12.7426 12.5517 9.04658 15.0108C8.96818 15.066 8.91298 15.1052 8.87783 15.1052C8.84267 15.1052 8.78747 15.066 8.71628 15.0108C5.01152 12.5517 1.7694 9.11584 1.7694 6.00451Z';
const SF_HEART_FILLED_PATH =
  'M8.99305 17.2095C9.24749 17.2095 9.62296 17.0026 9.95047 16.7961C14.826 13.632 17.9861 9.90469 17.9861 6.14098C17.9861 2.81445 15.6799 0.536133 12.8474 0.536133C11.0805 0.536133 9.77609 1.51051 8.99305 2.94952C8.222 1.5165 6.90284 0.536133 5.13866 0.536133C2.30623 0.536133 0 2.81445 0 6.14098C0 9.90469 3.16005 13.632 8.04162 16.7961C8.36314 17.0026 8.73581 17.2095 8.99305 17.2095Z';

type FavoriteHeartIconProps = {
  className?: string;
  filled: boolean;
  interactive?: boolean;
  size?: number;
};

export const FavoriteHeartIcon = ({
  className,
  filled,
  interactive = false,
  size = 18,
}: FavoriteHeartIconProps) => (
  <svg
    aria-hidden="true"
    className={cn(
      className,
      interactive &&
        'transition-colors group-hover/favorite:text-[#FF51AA] group-focus-visible/favorite:text-[#FF51AA]',
      filled && 'text-[#FF51AA]',
    )}
    width={size}
    height={size}
    viewBox={filled ? '0 0 18.3552 17.2095' : '0 0 18.1248 16.9766'}
    fill="currentColor"
    focusable="false"
  >
    <path d={filled ? SF_HEART_FILLED_PATH : SF_HEART_OUTLINE_PATH} />
  </svg>
);
